"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentDetailsFields = SegmentDetailsFields;
exports.SegmentSettings = SegmentSettings;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_dom_1 = require("react-dom");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var letsachieve_1 = require("../../../../../api/letsachieve");
var dangerZone_1 = require("../../../../../components/dangerZone");
var read_only_banner_1 = require("../../../../../components/readOnlyBanner/read_only_banner");
var sectionHeader_1 = require("../../../../../components/sectionHeader");
var routes_1 = require("../../../../../constants/routes");
var permissions_1 = require("../../../../../hooks/permissions");
var IUser_1 = require("../../../../../interfaces/IUser");
var main_1 = require("../../../../../reducers/slices/main");
var constants_1 = require("../constants");
var useDeleteSegment_1 = require("../hooks/useDeleteSegment");
var toFormData = function (segment) {
    var _a, _b, _c;
    return ({
        name: (_a = segment === null || segment === void 0 ? void 0 : segment.name) !== null && _a !== void 0 ? _a : "",
        description: (_b = segment === null || segment === void 0 ? void 0 : segment.description) !== null && _b !== void 0 ? _b : "",
        publish: (_c = segment === null || segment === void 0 ? void 0 : segment.publish) !== null && _c !== void 0 ? _c : false,
    });
};
function SegmentDetailsFields(_a) {
    var form_data = _a.form_data, on_change = _a.on_change, name_error = _a.name_error, is_read_only = _a.is_read_only;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { value: form_data.name, onChange: function (value) { return on_change("name", value); }, isRequired: true, isInvalid: !!name_error, isReadOnly: is_read_only, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Name" }), (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "High Value Customers" }), name_error ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: name_error }) : null] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { value: form_data.description, onChange: function (value) { return on_change("description", value); }, isReadOnly: is_read_only, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Description" }), (0, jsx_runtime_1.jsx)(react_1.TextArea, { placeholder: "Customers who have spent over R5000 in the last 30 days" })] }), (0, jsx_runtime_1.jsxs)(react_1.Switch, { isSelected: form_data.publish, onChange: function (isSelected) { return on_change("publish", isSelected); }, isDisabled: is_read_only, children: [(0, jsx_runtime_1.jsx)(react_1.Switch.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Switch.Thumb, {}) }), (0, jsx_runtime_1.jsx)(react_1.Switch.Content, { children: (0, jsx_runtime_1.jsx)(react_1.Label, { className: "text-sm", children: "Sync to Let's Trade" }) })] })] }));
}
function SegmentSettings(_a) {
    var _this = this;
    var segment = _a.segment, actions_container = _a.actions_container;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, permissions_1.usePermission)(IUser_1.IPermissions.SEGMENTS), canUpdate = _b.canUpdate, canDelete = _b.canDelete;
    var confirmDelete = (0, useDeleteSegment_1.useDeleteSegment)().confirmDelete;
    var _c = (0, letsachieve_1.useUpdateSegmentMutation)(), updateSegment = _c[0], isLoading = _c[1].isLoading;
    var _d = (0, react_3.useState)(function () { return toFormData(segment); }), formData = _d[0], setFormData = _d[1];
    var _e = (0, react_3.useState)(), nameError = _e[0], setNameError = _e[1];
    var _f = (0, react_3.useState)(false), isEdited = _f[0], setIsEdited = _f[1];
    // seeds the form only while nothing has been edited, so a background refetch cannot overwrite what is being typed
    (0, react_3.useEffect)(function () {
        if (!isEdited)
            setFormData(toFormData(segment));
    }, [segment, isEdited]);
    var handleChange = function (field, value) {
        setFormData(function (previous) {
            var _a;
            return (__assign(__assign({}, previous), (_a = {}, _a[field] = value, _a)));
        });
        setIsEdited(true);
        if (field === "name")
            setNameError(undefined);
    };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!formData.name.trim()) {
                        setNameError("Name is required");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateSegment({
                            segment_id: segment.id,
                            body: { name: formData.name.trim(), description: formData.description.trim(), publish: formData.publish },
                        }).unwrap()];
                case 2:
                    _a.sent();
                    setIsEdited(false);
                    dispatch((0, main_1.setMessageModal)({ title: "Success!", messages: ["Successfully updated segment."] }));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when updating your segment!", messages: [(0, constants_1.segmentErrorMessage)(error_1)] }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6 pt-4 pb-8", children: [canUpdate && actions_container
                ? (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsxs)(react_1.Button, { size: "md", onPress: handleSave, isPending: isLoading, isDisabled: !isEdited, variant: "primary", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:content-save", width: 24 }), "Save"] }), actions_container)
                : null, !canUpdate && (0, jsx_runtime_1.jsx)(read_only_banner_1.ReadOnlyBanner, { feature: "segments", className: "w-full" }), (0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 gap-8 md:grid-cols-2", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(sectionHeader_1.SectionHeader, { children: "Basic Information" }), (0, jsx_runtime_1.jsx)(SegmentDetailsFields, { form_data: formData, on_change: handleChange, name_error: nameError, is_read_only: !canUpdate })] }) }), canDelete && ((0, jsx_runtime_1.jsx)(dangerZone_1.DangerZone, { title: "Delete this segment", description: "Members are removed silently and its actions stop. History is kept.", button_label: "Delete segment", on_press: function () { return confirmDelete(segment, function () { return navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.SEGMENTS_ROUTE)); }); } }))] }));
}
